import type { Track } from '@typings/analytics';
import type { Dispatch } from '@typings/redux';
import { Logger } from '@utils/logger/logger';
import savedVendors from '@utils/savedVendors';
import { useCallback } from 'react';
import {
	fillFavoriteHeart,
	setSavedVendorId,
} from '../../favorites_button/actions';
import { useTrackAddToFavorites } from './use-track-add-to-favorites';

interface SavedVendor {
	id?: string | null;
	local_vendor?: { id: string };
}

// The bookings API saves the vendor as a favorite on booking, so we read it back instead of creating it.
export const useSyncFavorite = (
	vendor: Vendor.Decorated,
	sessionToken: string | null,
	track: Track,
	dispatch: Dispatch,
) => {
	const trackAddToFavorites = useTrackAddToFavorites(vendor, track);

	return useCallback(
		async (weddingId?: string) => {
			let response: { saved_vendors?: SavedVendor[] } | undefined;
			try {
				response = await savedVendors.get({ sessionToken, weddingId });
			} catch (error) {
				Logger.error({
					log_message: 'Error syncing favorite after booking',
					errorToLog: error as Error,
					newRelic: true,
				});
				return;
			}

			const favorite = response?.saved_vendors?.find(
				(savedVendor: SavedVendor) =>
					savedVendor.local_vendor?.id === vendor.id,
			);

			if (!favorite) return;

			dispatch(fillFavoriteHeart());
			trackAddToFavorites();
			dispatch(setSavedVendorId(favorite.id));
		},
		[vendor, sessionToken, trackAddToFavorites, dispatch],
	);
};
